export default {
    route: {
        login: "登入",
        dashboard: "仪表板",
        errorPages: '错误',
        page401: "错误 401",
        page404: "错误 404",
        photos: "照片",
        logout: '登出'
    },
    message: {
        success: "成功",
        username: "用户名",
        password: "密码",
        login: "登入",
    },
    required: {
        username: "必须填写用户名",
        password: "必须填写密码"
    },
    general: {
        close: "关闭",
        closeAll: "全部关闭",
        closeOthers: "其他关闭",
        refresh: "刷新",
    }
};
